import { render } from "./ExtraFieldsList.vue?vue&type=template&id=5af93152&scoped=true"
import script from "./ExtraFieldsList.vue?vue&type=script&lang=js"
export * from "./ExtraFieldsList.vue?vue&type=script&lang=js"

import "./ExtraFieldsList.vue?vue&type=style&index=0&id=5af93152&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af93152"]])

export default __exports__